/* R!PPED cart — drawer + /cart page share this file.
 *
 * Price rules (mirrors the store's Shopify settings — keep in sync with
 * build-log/phase-2-commerce.md "replay checklist"):
 *   - Combo of 3 = code COMBO3 (8%), Combo of 5 = code COMBO5 (12%).
 *     Applied only when the cart holds a COMPLETE combo built in the combo
 *     builder (lines carrying _combo_group / _combo_size properties).
 *   - KANMAN = 5% coupon for non-combo orders. Never stacks with a combo
 *     (all three codes have combinesWith = false in Shopify as well).
 *   - Delivery: Rs 49 below Rs 999 (after discount), FREE at Rs 999 and above.
 * Shopify applies one order code to the whole order, so the cart keeps the
 * right code on the cart through /cart/update.js { discount }.
 */
(function () {
  var CFG = window.RP_CART_CFG || {};
  var FREE_MIN = CFG.freeMin || 99900;
  var FEE = CFG.fee || 4900;
  var MRP = CFG.mrp || {};
  var COMBO = { 3: { code: 'COMBO3', pct: 8 }, 5: { code: 'COMBO5', pct: 12 } };
  var COMBO_CODES = ['COMBO3', 'COMBO5'];
  var COUPON = (CFG.coupon || 'KANMAN').toUpperCase();
  var COUPON_PCT = CFG.couponPct || 5;
  var COUPON_KEY = 'rp_coupon';

  var state = { cart: null, a: null, notice: '', couponMsg: '', couponOk: false, busy: false };

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    c = Math.round(c || 0);
    var r = c / 100;
    return '₹' + (c % 100 ? r.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : r.toLocaleString('en-IN'));
  }
  function colourName(t) { return t === 'Neon' ? 'Parrot Green' : (t === 'Grey' ? 'Slate Grey' : t); }

  function api(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Cart update failed');
        return j;
      });
    });
  }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); }); }
  function setCodes(codes) { return api('/cart/update.js', { discount: codes.join(',') }); }

  /* ---- combo analysis ---- */
  function analyse(cart) {
    var groups = [], map = {}, singles = [];
    cart.items.forEach(function (item, i) {
      var p = item.properties || {};
      var gid = p._combo_group;
      if (gid) {
        if (!map[gid]) { map[gid] = { id: gid, size: parseInt(p._combo_size, 10) || 0, lines: [], qty: 0, total: 0 }; groups.push(map[gid]); }
        map[gid].lines.push(item); map[gid].qty += item.quantity; map[gid].total += item.original_line_price;
      } else { singles.push(item); }
    });
    var comboSize = 0;
    groups.forEach(function (g) {
      g.complete = !!COMBO[g.size] && g.qty === g.size;
      if (g.complete && g.size > comboSize) comboSize = g.size;
    });
    return {
      groups: groups, singles: singles, comboSize: comboSize,
      comboCode: comboSize ? COMBO[comboSize].code : null,
      broken: groups.filter(function (g) { return !g.complete; })
    };
  }

  /* Decide which code(s) belong on the cart and fix it if needed. */
  function reconcile(cart) {
    var a = analyse(cart);
    var cur = codesOf(cart);
    var want;
    var saved = (lsGet(COUPON_KEY) || '').toUpperCase();
    if (!cart.items.length) return Promise.resolve(cart);
    if (a.comboCode) {
      want = [a.comboCode];
      if (cur.indexOf(COUPON) > -1) {
        state.notice = 'Coupon ' + COUPON + ' can’t be combined with a combo discount. Your combo ' + COMBO[a.comboSize].pct + '% is applied instead.';
      }
    } else {
      want = cur.filter(function (c) { return COMBO_CODES.indexOf(c) < 0; });
      if (saved && want.indexOf(saved) < 0) want.push(saved);
      var hadCombo = cur.some(function (c) { return COMBO_CODES.indexOf(c) > -1; });
      if (hadCombo && a.broken.length) {
        var g = a.broken[0];
        state.notice = 'Combo of ' + g.size + ' is incomplete (' + g.qty + '/' + g.size + ') — the ' + (COMBO[g.size] ? COMBO[g.size].pct : '') + '% combo discount was removed. ' +
          (g.qty < g.size ? 'Add ' + (g.size - g.qty) + ' more to this combo to get it back.' : 'Remove ' + (g.qty - g.size) + ' to get it back.');
      }
    }
    var same = want.length === cur.length && want.every(function (c) { return cur.indexOf(c) > -1; });
    if (same) return Promise.resolve(cart);
    return setCodes(want);
  }

  /* ---- rendering ---- */
  function thumb(item) {
    if (item.image) {
      var src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      return '<img class="rp-ci-img" src="' + esc(src) + '" alt="' + esc(item.product_title + ' — ' + colourName(item.variant_title)) + '" width="56" height="75" loading="lazy">';
    }
    return '<div class="cart-item-thumb sock-black"></div>';
  }
  function lineHTML(item, group) {
    var mrp = MRP[item.variant_id];
    var name = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + colourName(item.variant_title) : '');
    var incDisabled = group && group.qty >= group.size;
    return '<div class="cart-item">' + thumb(item) +
      '<div class="cart-item-info">' +
      '<div class="cart-item-name">' + esc(name) + '</div>' +
      '<div class="cart-item-price">' + money(item.original_price) +
      (mrp && mrp > item.original_price ? ' <s class="rp-mrp" aria-label="MRP">' + money(mrp) + '</s>' : '') +
      (item.quantity > 1 ? ' <span class="rp-x">× ' + item.quantity + ' = ' + money(item.original_line_price) + '</span>' : '') +
      '</div></div>' +
      '<div class="cart-item-r">' +
      '<div class="cart-qty">' +
      '<button type="button" data-rp-qty="-1" data-key="' + esc(item.key) + '" aria-label="Decrease quantity of ' + esc(name) + '">−</button>' +
      '<span aria-live="polite">' + item.quantity + '</span>' +
      '<button type="button" data-rp-qty="1" data-key="' + esc(item.key) + '" aria-label="Increase quantity of ' + esc(name) + '"' + (incDisabled ? ' disabled title="Combo is full"' : '') + '>+</button>' +
      '</div>' +
      '<button type="button" class="cart-item-remove" data-rp-remove data-key="' + esc(item.key) + '" aria-label="Remove ' + esc(name) + '">×</button>' +
      '</div></div>';
  }
  function itemsHTML(cart, a) {
    if (!cart.items.length) {
      return '<div class="cart-empty"><svg width="42" height="42" viewBox="0 0 24 24" style="stroke:rgba(255,255,255,.12);fill:none;stroke-width:1"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><span class="cart-et">Your bag is empty</span><div class="cart-empty-cta"><a href="/pages/top-sellers" class="btn-primary"><span>Shop best sellers</span></a><a href="/pages/combo" class="btn-ghost">Build a combo</a></div></div>';
    }
    var html = '';
    if (state.notice) html += '<div class="rp-cart-notice" role="status">' + esc(state.notice) + '</div>';
    a.groups.forEach(function (g) {
      var pct = COMBO[g.size] ? COMBO[g.size].pct : 0;
      var status = g.complete ? '✓ ' + g.qty + '/' + g.size + ' · ' + pct + '% off' : 'Incomplete ' + g.qty + '/' + g.size + ' · no combo discount';
      html += '<div class="cart-combo-group' + (g.complete ? '' : ' rp-combo-broken') + '">' +
        '<div class="cart-combo-header"><span class="cart-combo-badge">Combo of ' + g.size + '</span>' +
        '<span class="rp-combo-status">' + status + '</span>' +
        '<button type="button" class="rp-link" data-rp-remove-group="' + esc(g.id) + '" aria-label="Remove this combo">Remove combo</button></div>' +
        '<div class="cart-combo-items">' + g.lines.map(function (it) { return lineHTML(it, g); }).join('') + '</div></div>';
    });
    html += a.singles.map(function (it) { return lineHTML(it, null); }).join('');
    return html;
  }
  function discountLabel(cart) {
    var apps = cart.cart_level_discount_applications || [];
    if (!apps.length) return 'Discount';
    /* /cart.js returns flat objects; /cart/update.js nests them under discount_application */
    var app = apps[0].discount_application || apps[0];
    var t = String(app.title || '').toUpperCase();
    if (t === 'COMBO3') return 'Combo of 3 (8%)';
    if (t === 'COMBO5') return 'Combo of 5 (12%)';
    if (t === COUPON) return 'Coupon ' + COUPON + ' (' + COUPON_PCT + '%)';
    return 'Discount (' + esc(app.title) + ')';
  }
  function summaryHTML(cart, a) {
    if (!cart.items.length) return '';
    var sub = cart.original_total_price;
    var after = cart.total_price;
    var disc = sub - after;
    var free = after >= FREE_MIN;
    var delivery = free ? 0 : FEE;
    var gap = FREE_MIN - after;
    var pctBar = Math.max(0, Math.min(100, Math.round(after / FREE_MIN * 100)));
    var codes = codesOf(cart);
    var saved = (lsGet(COUPON_KEY) || '').toUpperCase();
    var couponApplied = codes.indexOf(COUPON) > -1 && (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === COUPON && d.applicable; });
    var h = '';
    h += '<div class="rp-ship-meter">' + (free
      ? '<p class="rp-ship-msg ok">✓ You’ve unlocked FREE delivery</p>'
      : '<p class="rp-ship-msg">Add <strong>' + money(gap) + '</strong> more for FREE delivery</p>') +
      '<div class="rp-ship-bar" aria-hidden="true"><span style="width:' + pctBar + '%"></span></div></div>';
    h += '<dl class="rp-sum">';
    /* 3-Nov (Manit): Subtotal + Delivery = Total, then − discount = Estimated total */
    h += '<div class="rp-sum-row"><dt>Subtotal</dt><dd>' + money(sub) + '</dd></div>';
    h += '<div class="rp-sum-row"><dt>+ Delivery</dt><dd>' + (free ? '<span class="rp-free">FREE</span>' : money(FEE)) + '</dd></div>';
    if (disc > 0) {
      h += '<div class="rp-sum-row sub"><dt>Total</dt><dd>' + money(sub + delivery) + '</dd></div>';
      h += '<div class="rp-sum-row disc"><dt>− ' + discountLabel(cart) + '</dt><dd>−' + money(disc) + '</dd></div>';
    }
    h += '<div class="rp-sum-row total"><dt>Estimated total</dt><dd>' + money(after + delivery) + '</dd></div>';
    h += '</dl>';
    h += '<p class="rp-sum-note">Inclusive of all taxes. Delivery ₹49 below ₹999, FREE on ₹999 and above.</p>';
    /* coupon */
    if (a.comboCode) {
      h += '<p class="rp-coupon-note">Combo discount applied. Coupon codes can’t be combined with combos.</p>';
    } else if (couponApplied) {
      h += '<div class="rp-coupon-applied">Coupon <strong>' + COUPON + '</strong> applied (' + COUPON_PCT + '% off) <button type="button" class="rp-link" data-rp-coupon-remove="' + COUPON + '">Remove</button></div>';
    } else {
      h += '<form class="rp-coupon" data-rp-coupon-form novalidate>' +
        '<label class="rp-visually-hidden" for="rpCoupon' + (state._n = (state._n || 0) + 1) + '">Coupon code</label>' +
        '<input id="rpCoupon' + state._n + '" name="code" type="text" autocomplete="off" autocapitalize="characters" placeholder="Coupon code (e.g. ' + COUPON + ')">' +
        '<button type="submit">Apply</button></form>';
    }
    if (state.couponMsg) h += '<p class="rp-coupon-msg' + (state.couponOk ? ' ok' : '') + '" role="status">' + esc(state.couponMsg) + '</p>';
    return h;
  }

  function paint(cart) {
    var a = analyse(cart);
    state.cart = cart; state.a = a;
    window._cartLines = cart.items;
    document.querySelectorAll('[data-rp-cart-items]').forEach(function (el) { el.innerHTML = itemsHTML(cart, a); });
    document.querySelectorAll('[data-rp-cart-summary]').forEach(function (el) { el.innerHTML = summaryHTML(cart, a); });
    document.querySelectorAll('[data-rp-cart-footer]').forEach(function (el) { el.style.display = cart.items.length ? '' : 'none'; });
    document.querySelectorAll('[data-rp-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
  }

  var chain = Promise.resolve();
  function queue(fn) {
    chain = chain.then(fn).then(function (cart) { return reconcile(cart); }).then(paint).catch(function (err) {
      state.notice = err && err.message ? err.message : 'Something went wrong. Please try again.';
      return api('/cart.js').then(paint);
    });
    return chain;
  }
  function refresh() { return queue(function () { return api('/cart.js'); }); }

  /* ---- actions ---- */
  function findItem(key) { var c = state.cart; if (!c) return null; for (var i = 0; i < c.items.length; i++) if (c.items[i].key === key) return c.items[i]; return null; }
  function changeKey(key, qty) { state.notice = ''; state.couponMsg = ''; return queue(function () { return api('/cart/change.js', { id: key, quantity: Math.max(0, qty) }); }); }

  function applyCoupon(raw) {
    var code = String(raw || '').trim().toUpperCase();
    state.notice = '';
    if (!code) { state.couponMsg = 'Enter a coupon code.'; state.couponOk = false; return paint(state.cart); }
    if (COMBO_CODES.indexOf(code) > -1) {
      state.couponMsg = 'Combo discounts apply automatically when you build a 3- or 5-sock combo.'; state.couponOk = false; return paint(state.cart);
    }
    if (state.a && state.a.comboCode) {
      state.couponMsg = code + ' can’t be combined with your combo discount. One discount per order.'; state.couponOk = false; return paint(state.cart);
    }
    return queue(function () {
      return setCodes([code]).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code; })[0];
        if (hit && hit.applicable) { lsSet(COUPON_KEY, code); state.couponMsg = 'Coupon ' + code + ' applied.'; state.couponOk = true; return cart; }
        state.couponMsg = 'Coupon ' + code + ' isn’t valid for this order.'; state.couponOk = false;
        if (lsGet(COUPON_KEY) === code) lsDel(COUPON_KEY);
        return setCodes([]);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-rp-qty]');
    if (q) {
      if (q.disabled) return;
      var it = findItem(q.getAttribute('data-key')); if (!it) return;
      changeKey(it.key, it.quantity + parseInt(q.getAttribute('data-rp-qty'), 10));
      return;
    }
    var rm = e.target.closest('[data-rp-remove]');
    if (rm) { changeKey(rm.getAttribute('data-key'), 0); return; }
    var rg = e.target.closest('[data-rp-remove-group]');
    if (rg) {
      var gid = rg.getAttribute('data-rp-remove-group');
      var updates = {};
      (state.cart ? state.cart.items : []).forEach(function (it) { if (it.properties && it.properties._combo_group === gid) updates[it.key] = 0; });
      state.notice = ''; state.couponMsg = '';
      queue(function () { return api('/cart/update.js', { updates: updates }); });
      return;
    }
    var cr = e.target.closest('[data-rp-coupon-remove]');
    if (cr) {
      lsDel(COUPON_KEY); state.couponMsg = ''; state.notice = '';
      var keep = codesOf(state.cart).filter(function (c) { return c !== cr.getAttribute('data-rp-coupon-remove'); });
      queue(function () { return setCodes(keep); });
      return;
    }
    var co = e.target.closest('[data-rp-checkout]');
    if (co) {
      e.preventDefault();
      /* make sure the code on the cart is the right one before leaving */
      refresh().then(function () { window.location.href = '/checkout'; });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-rp-coupon-form]');
    if (!f) return;
    e.preventDefault();
    applyCoupon(f.querySelector('input').value);
  });

  /* ---- public API (names kept from the original theme) ---- */
  window.RPCart = { refresh: refresh, applyCoupon: applyCoupon, analyse: analyse };
  window.renderCart = refresh;
  window.openCart = function () {
    var d = document.getElementById('cartDrawer'); if (!d) return;
    d.classList.add('open'); document.getElementById('cartVeil').classList.add('open');
    document.body.style.overflow = 'hidden'; refresh();
  };
  window.closeCart = function () {
    var d = document.getElementById('cartDrawer'); if (!d) return;
    d.classList.remove('open'); document.getElementById('cartVeil').classList.remove('open');
    document.body.style.overflow = '';
  };
  window.clearBag = function () {
    state.notice = ''; state.couponMsg = '';
    queue(function () { return api('/cart/clear.js', {}); });
  };
  /* legacy helpers, index-based */
  window.changeQty = function (idx, delta) { var it = state.cart && state.cart.items[idx]; if (it) changeKey(it.key, it.quantity + delta); };
  window.removeLine = function (line) { var it = state.cart && state.cart.items[line - 1]; if (it) changeKey(it.key, 0); };
  document.addEventListener('cart:updated', function () { refresh(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.closeCart(); });
})();
